import { useProtocolDefinitions } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ProgramEdit } from "@/features/catalog";

export const Route = createFileRoute("/catalog/procedures/new")({
  beforeLoad: ({ context }) => {
    const { permissions } = context;
    if (!permissions.canWrite("PlanDefinition")) {
      throw redirect({ to: "/catalog/procedures" });
    }
  },
  component: NewCatalogItemComponent,
});

function NewCatalogItemComponent() {
  const navigate = useNavigate();
  const protocolDefinitions = useProtocolDefinitions({ availability: "Active" });

  const backToProcedures = () => navigate({ to: "/catalog/procedures" });

  return (
    <ProgramEdit protocolItems={protocolDefinitions} canEdit onDone={backToProcedures} onCancel={backToProcedures} />
  );
}
